var map = {
	"./src/banners": [
		83589,
		83589
	],
	"./src/banners.ts": [
		83589,
		83589
	],
	"./src/cctp/cctp-faq/index.mdx": [
		36211,
		2044,
		51419,
		45608,
		36720,
		12314,
		36211
	],
	"./src/cctp/cctp-supported-blockchains/index.mdx": [
		62010,
		2044,
		51419,
		45608,
		36720,
		12314,
		62010
	],
	"./src/cctp/evm-smart-contracts/index.mdx": [
		88204,
		2044,
		51419,
		45608,
		36720,
		12314,
		88204
	],
	"./src/cctp/images/cctp-gmp-archdomains01.png": [
		65062,
		65062
	],
	"./src/cctp/index.mdx": [
		55717,
		2044,
		51419,
		45608,
		36720,
		12314,
		94052
	],
	"./src/cctp/required-block-confirmations/index.mdx": [
		31088,
		2044,
		51419,
		45608,
		36720,
		12314,
		31088
	],
	"./src/cctp/solana-programs/index.mdx": [
		60039,
		2044,
		51419,
		45608,
		36720,
		12314,
		60039
	],
	"./src/cctp/technical-guide/index.mdx": [
		61122,
		2044,
		51419,
		45608,
		36720,
		12314,
		61122
	],
	"./src/cctp/transfer-usdc-on-testnet-from-ethereum-to-avalanche/index.mdx": [
		96510,
		2044,
		51419,
		45608,
		36720,
		12314,
		96510
	],
	"./src/cctp/v1/aptos-packages/index.mdx": [
		11795,
		2044,
		51419,
		45608,
		36720,
		12314,
		38251
	],
	"./src/cctp/v1/cctp-apis/index.mdx": [
		16692,
		2044,
		51419,
		45608,
		36720,
		12314,
		16692
	],
	"./src/cctp/v1/cctp-supported-blockchains/index.mdx": [
		25449,
		2044,
		51419,
		45608,
		36720,
		12314,
		25449
	],
	"./src/cctp/v1/evm-smart-contracts/index.mdx": [
		47866,
		2044,
		51419,
		45608,
		36720,
		12314,
		47866
	],
	"./src/cctp/v1/generic-message-passing/index.mdx": [
		66725,
		2044,
		51419,
		45608,
		36720,
		12314,
		66725
	],
	"./src/cctp/v1/images/cctp-gmp-archdomains01.png": [
		12124,
		12124
	],
	"./src/cctp/v1/index.mdx": [
		84908,
		2044,
		51419,
		45608,
		36720,
		12314,
		84908
	],
	"./src/cctp/v1/limits/index.mdx": [
		20943,
		2044,
		51419,
		45608,
		36720,
		12314,
		20943
	],
	"./src/cctp/v1/message-format/index.mdx": [
		30674,
		2044,
		51419,
		45608,
		36720,
		12314,
		30674
	],
	"./src/cctp/v1/noble-cosmos-module/index.mdx": [
		96207,
		2044,
		51419,
		45608,
		36720,
		12314,
		96207
	],
	"./src/cctp/v1/required-block-confirmations/index.mdx": [
		73482,
		2044,
		51419,
		45608,
		36720,
		12314,
		73482
	],
	"./src/cctp/v1/solana-programs/index.mdx": [
		92338,
		2044,
		51419,
		45608,
		36720,
		12314,
		92338
	],
	"./src/cctp/v1/sui-packages/index.mdx": [
		80400,
		2044,
		51419,
		45608,
		36720,
		12314,
		80400
	],
	"./src/cctp/v1/supported-domains/index.mdx": [
		74882,
		2044,
		51419,
		45608,
		36720,
		12314,
		74882
	],
	"./src/cctp/v1/transfer-testnet-usdc-between-solana-devnet/index.mdx": [
		27067,
		2044,
		51419,
		45608,
		36720,
		12314,
		27067
	],
	"./src/cctp/v1/transfer-usdc-on-testnet-from-aptos-to-base/index.mdx": [
		19979,
		2044,
		51419,
		45608,
		36720,
		12314,
		19979
	],
	"./src/cctp/v1/transfer-usdc-on-testnet-from-ethereum-to-avalanche/index.mdx": [
		76001,
		2044,
		51419,
		45608,
		36720,
		12314,
		76001
	],
	"./src/cctp/v1/transfer-usdc-on-testnet-from-noble-to-ethereum/index.mdx": [
		50863,
		2044,
		51419,
		45608,
		36720,
		12314,
		50863
	],
	"./src/cctp/v1/transfer-usdc-on-testnet-from-sui-to-ethereum/index.mdx": [
		42599,
		2044,
		51419,
		45608,
		36720,
		12314,
		42599
	],
	"./src/circle-mint/a-note-on-idempotent-requests/index.mdx": [
		77672,
		2044,
		51419,
		45608,
		36720,
		12314,
		77672
	],
	"./src/circle-mint/api-keys/index.mdx": [
		97112,
		2044,
		51419,
		45608,
		36720,
		12314,
		97112
	],
	"./src/circle-mint/api-logs/index.mdx": [
		73189,
		2044,
		51419,
		45608,
		36720,
		12314,
		73189
	],
	"./src/circle-mint/authentication/index.mdx": [
		82696,
		2044,
		51419,
		45608,
		36720,
		12314,
		82696
	],
	"./src/circle-mint/blockchain-confirmations/index.mdx": [
		98950,
		2044,
		51419,
		45608,
		36720,
		12314,
		98950
	],
	"./src/circle-mint/circle-api-resources/index.mdx": [
		28291,
		2044,
		51419,
		45608,
		36720,
		12314,
		28291
	],
	"./src/circle-mint/circle-apis-api-errors/index.mdx": [
		94813,
		2044,
		51419,
		45608,
		36720,
		12314,
		94813
	],
	"./src/circle-mint/circle-apis-notifications-quickstart/index.mdx": [
		47954,
		2044,
		51419,
		45608,
		36720,
		12314,
		47954
	],
	"./src/circle-mint/circle-apis-production-sandbox-environments/index.mdx": [
		82042,
		2044,
		51419,
		45608,
		36720,
		12314,
		82042
	],
	"./src/circle-mint/circle-sdks/index.mdx": [
		35853,
		2044,
		51419,
		45608,
		36720,
		12314,
		35853
	],
	"./src/circle-mint/crypto-payments-quickstart/index.mdx": [
		48296,
		2044,
		51419,
		45608,
		36720,
		12314,
		48296
	],
	"./src/circle-mint/crypto-payouts/index.mdx": [
		73012,
		2044,
		51419,
		45608,
		36720,
		12314,
		73012
	],
	"./src/circle-mint/crypto-refunds/index.mdx": [
		40330,
		2044,
		51419,
		45608,
		36720,
		12314,
		40330
	],
	"./src/circle-mint/getting-started-with-the-circle-apis/index.mdx": [
		48919,
		2044,
		51419,
		45608,
		36720,
		12314,
		48919
	],
	"./src/circle-mint/getting-started-with-the-circle-core-api/index.mdx": [
		47154,
		2044,
		51419,
		45608,
		36720,
		12314,
		47154
	],
	"./src/circle-mint/images/apil-dash01.jpg": [
		31085,
		31085
	],
	"./src/circle-mint/images/apil-searchfilters01.jpg": [
		35966,
		35966
	],
	"./src/circle-mint/images/dt-ps-accountsapi01.png": [
		78248,
		78248
	],
	"./src/circle-mint/images/mws-dash-subs01.jpg": [
		96861,
		96861
	],
	"./src/circle-mint/images/nq-subscription01.png": [
		50560,
		50560
	],
	"./src/circle-mint/images/nq-subscription02.png": [
		78908,
		78908
	],
	"./src/circle-mint/images/nq-subscription03.png": [
		6588,
		6588
	],
	"./src/circle-mint/images/nq-webhookurl01.png": [
		92289,
		92289
	],
	"./src/circle-mint/images/qscp-gasfeediagram01.png": [
		1985,
		1985
	],
	"./src/circle-mint/images/qscp-seqdiagram01.png": [
		49288,
		49288
	],
	"./src/circle-mint/images/qscp-sigreq01.png": [
		63728,
		63728
	],
	"./src/circle-mint/introducing-circle-mint/index.mdx": [
		88887,
		2044,
		51419,
		45608,
		36720,
		12314,
		88887
	],
	"./src/circle-mint/notifications-data-models/index.mdx": [
		86311,
		2044,
		51419,
		45608,
		36720,
		12314,
		86311
	],
	"./src/circle-mint/openapi/index.mdx": [
		7131,
		2044,
		51419,
		45608,
		36720,
		12314,
		7131
	],
	"./src/circle-mint/overview/index.mdx": [
		9788,
		2044,
		51419,
		45608,
		36720,
		12314,
		9788
	],
	"./src/circle-mint/pagination-and-filtering/index.mdx": [
		51362,
		2044,
		51419,
		45608,
		36720,
		12314,
		51362
	],
	"./src/circle-mint/postman/index.mdx": [
		9142,
		2044,
		51419,
		45608,
		36720,
		12314,
		9142
	],
	"./src/circle-mint/quickstart-deposit-via-blockchain-wallet/index.mdx": [
		42265,
		2044,
		51419,
		45608,
		36720,
		12314,
		42265
	],
	"./src/circle-mint/quickstart-deposit-via-funds-transfer/index.mdx": [
		84073,
		2044,
		51419,
		45608,
		36720,
		12314,
		84073
	],
	"./src/circle-mint/quickstart-withdraw-to-bank/index.mdx": [
		60970,
		2044,
		51419,
		45608,
		36720,
		12314,
		60970
	],
	"./src/circle-mint/quickstart-withdraw-via-blockchain-wallet/index.mdx": [
		85383,
		2044,
		51419,
		45608,
		36720,
		12314,
		85383
	],
	"./src/circle-mint/sandbox-to-production-transition-guide/index.mdx": [
		94858,
		2044,
		51419,
		45608,
		36720,
		12314,
		94858
	],
	"./src/circle-mint/supported-chains-and-currencies/index.mdx": [
		27862,
		2044,
		51419,
		45608,
		36720,
		12314,
		27862
	],
	"./src/circle-mint/supported-countries/index.mdx": [
		2891,
		2044,
		51419,
		45608,
		36720,
		12314,
		2891
	],
	"./src/circle-mint/testing-connectivity-and-api-keys/index.mdx": [
		31392,
		2044,
		51419,
		45608,
		36720,
		12314,
		31392
	],
	"./src/circle-mint/travel-rule-on-chain/index.mdx": [
		89280,
		2044,
		51419,
		45608,
		36720,
		12314,
		89280
	],
	"./src/circle-mint/webhook-subscription-management/index.mdx": [
		68901,
		2044,
		51419,
		45608,
		36720,
		12314,
		68901
	],
	"./src/circle-mint/wire-virtual-account-number/index.mdx": [
		9675,
		2044,
		51419,
		45608,
		36720,
		12314,
		9675
	],
	"./src/common/prerequisites.mdx": [
		24985,
		2044,
		51419,
		45608,
		36720,
		12314,
		24985
	],
	"./src/cpn/explanation/integration-concepts/index.mdx": [
		1124,
		2044,
		51419,
		45608,
		36720,
		12314,
		1124
	],
	"./src/cpn/howtos/create-an-onchain-txn/index.mdx": [
		69339,
		2044,
		51419,
		45608,
		36720,
		12314,
		69339
	],
	"./src/cpn/howtos/create-support-ticket/index.mdx": [
		48884,
		2044,
		51419,
		45608,
		36720,
		12314,
		48884
	],
	"./src/cpn/howtos/encrypt-files/index.mdx": [
		8104,
		2044,
		51419,
		45608,
		36720,
		12314,
		8104
	],
	"./src/cpn/howtos/encrypt-travel-rule-beneficiary-data/index.mdx": [
		28897,
		2044,
		51419,
		45608,
		36720,
		12314,
		28897
	],
	"./src/cpn/howtos/integrate-with-json-schema/index.mdx": [
		55315,
		2044,
		51419,
		45608,
		36720,
		12314,
		55315
	],
	"./src/cpn/howtos/request-payment-config/index.mdx": [
		14834,
		2044,
		51419,
		45608,
		36720,
		12314,
		14834
	],
	"./src/cpn/howtos/setup-webhook-notifications/index.mdx": [
		710,
		2044,
		51419,
		45608,
		36720,
		12314,
		710
	],
	"./src/cpn/howtos/verify-webhook-signatures/index.mdx": [
		44005,
		2044,
		51419,
		45608,
		36720,
		12314,
		44005
	],
	"./src/cpn/images/cpn-overview.png": [
		44439,
		44439
	],
	"./src/cpn/images/cpn-workflow.png": [
		65014,
		65014
	],
	"./src/cpn/images/payment-workflow.png": [
		3718,
		3718
	],
	"./src/cpn/images/refund-workflow.png": [
		50006,
		50006
	],
	"./src/cpn/images/rfi-workflow.png": [
		90734,
		90734
	],
	"./src/cpn/images/support-ticket-workflow.png": [
		11193,
		11193
	],
	"./src/cpn/images/transaction-workflow.png": [
		23387,
		23387
	],
	"./src/cpn/index.mdx": [
		75520,
		2044,
		51419,
		45608,
		36720,
		12314,
		75520
	],
	"./src/cpn/quickstarts/integrate-with-cpn-ofi/index.mdx": [
		40511,
		2044,
		51419,
		45608,
		36720,
		12314,
		40511
	],
	"./src/cpn/references/component-states-and-workflows/index.mdx": [
		93159,
		2044,
		51419,
		45608,
		36720,
		12314,
		93159
	],
	"./src/cpn/references/error-codes/index.mdx": [
		59691,
		2044,
		51419,
		45608,
		36720,
		12314,
		59691
	],
	"./src/cpn/references/json-schema/index.mdx": [
		94844,
		2044,
		51419,
		45608,
		36720,
		12314,
		94844
	],
	"./src/cpn/references/magic-values/index.mdx": [
		12983,
		2044,
		51419,
		45608,
		36720,
		12314,
		12983
	],
	"./src/cpn/references/payment-and-transaction-failure-reasons/index.mdx": [
		34534,
		2044,
		51419,
		45608,
		36720,
		12314,
		34534
	],
	"./src/cpn/references/payment-failure-codes/index.mdx": [
		36939,
		2044,
		51419,
		45608,
		36720,
		12314,
		36939
	],
	"./src/cpn/references/payment-reason-codes/index.mdx": [
		80669,
		2044,
		51419,
		45608,
		36720,
		12314,
		80669
	],
	"./src/cpn/references/payment-reference/index.mdx": [
		30045,
		2044,
		51419,
		45608,
		36720,
		12314,
		30045
	],
	"./src/cpn/references/rfi-levels/index.mdx": [
		85460,
		2044,
		51419,
		45608,
		36720,
		12314,
		85460
	],
	"./src/cpn/references/supported-blockchains/index.mdx": [
		23728,
		2044,
		51419,
		45608,
		36720,
		12314,
		87112
	],
	"./src/cpn/references/travel-rule-requirements/index.mdx": [
		49542,
		2044,
		51419,
		45608,
		36720,
		12314,
		49542
	],
	"./src/cpn/references/validating-brazil-tax-account-id/index.mdx": [
		68010,
		2044,
		51419,
		45608,
		36720,
		12314,
		68010
	],
	"./src/cpn/references/wallet-provider-compatibility/index.mdx": [
		74769,
		2044,
		51419,
		45608,
		36720,
		12314,
		74769
	],
	"./src/cpn/references/webhook-events/index.mdx": [
		3828,
		2044,
		51419,
		45608,
		36720,
		12314,
		3828
	],
	"./src/cpn/references/webhook-retries/index.mdx": [
		70942,
		2044,
		51419,
		45608,
		36720,
		12314,
		70942
	],
	"./src/dev-controlled-wallets/create-wallet.mdx": [
		55374,
		2044,
		51419,
		45608,
		36720,
		12314,
		55374
	],
	"./src/dev-controlled-wallets/images/cipher_text_registration.png": [
		12075,
		12075
	],
	"./src/dev-controlled-wallets/images/explorer.png": [
		11194,
		11194
	],
	"./src/dev-controlled-wallets/images/transactions.png": [
		25394,
		25394
	],
	"./src/dev-controlled-wallets/index.mdx": [
		4485,
		2044,
		51419,
		45608,
		36720,
		12314,
		4485
	],
	"./src/dev-controlled-wallets/initiate-transaction.mdx": [
		19886,
		2044,
		51419,
		45608,
		36720,
		12314,
		19886
	],
	"./src/dev-controlled-wallets/introduction.mdx": [
		99429,
		2044,
		51419,
		45608,
		36720,
		12314,
		99429
	],
	"./src/dev-controlled-wallets/next-steps.mdx": [
		71442,
		2044,
		51419,
		45608,
		36720,
		12314,
		71442
	],
	"./src/dev-controlled-wallets/setup-entity-secret.mdx": [
		35126,
		2044,
		51419,
		45608,
		36720,
		12314,
		35126
	],
	"./src/gateway/common/deposit-warning.mdx": [
		71361,
		2044,
		51419,
		45608,
		36720,
		12314,
		71361
	],
	"./src/gateway/explanation/faq/index.mdx": [
		47780,
		2044,
		51419,
		45608,
		36720,
		12314,
		47780
	],
	"./src/gateway/explanation/technical-guide/index.mdx": [
		66870,
		2044,
		51419,
		45608,
		36720,
		12314,
		66870
	],
	"./src/gateway/howtos/create-unified-usdc-balance/index.mdx": [
		46468,
		2044,
		51419,
		45608,
		36720,
		12314,
		46468
	],
	"./src/gateway/howtos/transfer-unified-usdc-balance/index.mdx": [
		46806,
		2044,
		51419,
		45608,
		36720,
		12314,
		46806
	],
	"./src/gateway/images/gateway-overview.png": [
		47651,
		47651
	],
	"./src/gateway/index.mdx": [
		40741,
		2044,
		51419,
		45608,
		36720,
		12314,
		40741
	],
	"./src/gateway/quickstarts/unified-balance/index.mdx": [
		72303,
		2044,
		51419,
		45608,
		36720,
		12314,
		72303
	],
	"./src/gateway/references/contract-addresses/index.mdx": [
		19074,
		2044,
		51419,
		45608,
		36720,
		12314,
		19074
	],
	"./src/gateway/references/contract-interfaces-and-events/index.mdx": [
		5476,
		2044,
		51419,
		45608,
		36720,
		12314,
		5476
	],
	"./src/gateway/references/fees/index.mdx": [
		69729,
		2044,
		51419,
		45608,
		36720,
		12314,
		69729
	],
	"./src/gateway/references/supported-blockchains/index.mdx": [
		51050,
		2044,
		51419,
		45608,
		36720,
		12314,
		51050
	],
	"./src/get-started/create-api-key.mdx": [
		31039,
		2044,
		51419,
		45608,
		36720,
		12314,
		31039
	],
	"./src/get-started/create-web3-service-account.mdx": [
		19361,
		2044,
		51419,
		45608,
		36720,
		12314,
		19361
	],
	"./src/get-started/images/api_key_created.png": [
		8567,
		8567
	],
	"./src/get-started/images/api_keys.png": [
		71438,
		71438
	],
	"./src/get-started/images/create_key.png": [
		73149,
		73149
	],
	"./src/get-started/images/mainnet.png": [
		59241,
		59241
	],
	"./src/get-started/images/testnet.png": [
		10132,
		10132
	],
	"./src/get-started/index.mdx": [
		18144,
		2044,
		51419,
		45608,
		36720,
		12314,
		18144
	],
	"./src/get-started/power-of-testnet.mdx": [
		34595,
		2044,
		51419,
		45608,
		36720,
		12314,
		34595
	],
	"./src/get-started/testnet-vs-mainnet.mdx": [
		69928,
		2044,
		51419,
		45608,
		36720,
		12314,
		69928
	],
	"./src/interactive-quickstarts/cctp/approve-burn.mdx": [
		86431,
		2044,
		51419,
		45608,
		36720,
		12314,
		86431
	],
	"./src/interactive-quickstarts/cctp/burn-usdc/images/successful-burn.png": [
		25349,
		25349
	],
	"./src/interactive-quickstarts/cctp/burn-usdc/index.mdx": [
		42722,
		2044,
		51419,
		45608,
		36720,
		12314,
		31549
	],
	"./src/interactive-quickstarts/cctp/index.mdx": [
		58258,
		2044,
		51419,
		45608,
		36720,
		12314,
		58258
	],
	"./src/interactive-quickstarts/cctp/introduction/images/burn-usdc.png": [
		23223,
		23223
	],
	"./src/interactive-quickstarts/cctp/introduction/images/fetch-attestation.png": [
		18263,
		18263
	],
	"./src/interactive-quickstarts/cctp/introduction/images/mint-usdc.png": [
		277,
		277
	],
	"./src/interactive-quickstarts/cctp/introduction/index.mdx": [
		76442,
		2044,
		51419,
		45608,
		36720,
		12314,
		76442
	],
	"./src/interactive-quickstarts/cctp/mint-usdc.mdx": [
		41815,
		2044,
		51419,
		45608,
		36720,
		12314,
		24453
	],
	"./src/interactive-quickstarts/cctp/next-steps.mdx": [
		4099,
		2044,
		51419,
		45608,
		36720,
		12314,
		4099
	],
	"./src/interactive-quickstarts/cctp/prerequisites.mdx": [
		94248,
		2044,
		51419,
		45608,
		36720,
		12314,
		94248
	],
	"./src/interactive-quickstarts/common/prerequisites.mdx": [
		88457,
		2044,
		51419,
		45608,
		36720,
		12314,
		88457
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/create-wallet.mdx": [
		53606,
		2044,
		51419,
		45608,
		36720,
		12314,
		53606
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/images/cipher_text_registration.png": [
		27616,
		27616
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/images/explorer.png": [
		4668,
		20836
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/images/transactions.png": [
		21698,
		21698
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/index.mdx": [
		88441,
		2044,
		51419,
		45608,
		36720,
		12314,
		88441
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/initiate-transaction.mdx": [
		41324,
		2044,
		51419,
		45608,
		36720,
		12314,
		41324
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/introduction.mdx": [
		79184,
		2044,
		51419,
		45608,
		36720,
		12314,
		79184
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/next-steps.mdx": [
		3388,
		2044,
		51419,
		45608,
		36720,
		12314,
		3388
	],
	"./src/interactive-quickstarts/dev-controlled-wallets/setup-entity-secret.mdx": [
		69522,
		2044,
		51419,
		45608,
		36720,
		12314,
		69522
	],
	"./src/interactive-quickstarts/get-started/create-api-key.mdx": [
		54708,
		2044,
		51419,
		45608,
		36720,
		12314,
		54708
	],
	"./src/interactive-quickstarts/get-started/create-web3-service-account.mdx": [
		56786,
		2044,
		51419,
		45608,
		36720,
		12314,
		56786
	],
	"./src/interactive-quickstarts/get-started/images/api_key_created.png": [
		2248,
		2248
	],
	"./src/interactive-quickstarts/get-started/images/api_keys.png": [
		43369,
		43369
	],
	"./src/interactive-quickstarts/get-started/images/create_key.png": [
		95301,
		95301
	],
	"./src/interactive-quickstarts/get-started/images/mainnet.png": [
		17567,
		17567
	],
	"./src/interactive-quickstarts/get-started/images/testnet.png": [
		4447,
		4447
	],
	"./src/interactive-quickstarts/get-started/index.mdx": [
		70863,
		2044,
		51419,
		45608,
		36720,
		12314,
		70863
	],
	"./src/interactive-quickstarts/get-started/power-of-testnet.mdx": [
		70491,
		2044,
		51419,
		45608,
		36720,
		12314,
		70491
	],
	"./src/interactive-quickstarts/get-started/testnet-vs-mainnet.mdx": [
		68426,
		2044,
		51419,
		45608,
		36720,
		12314,
		68426
	],
	"./src/interactive-quickstarts/index.mdx": [
		75810,
		2044,
		51419,
		45608,
		36720,
		12314,
		75810
	],
	"./src/interactive-quickstarts/quickstarts.mdx": [
		6763,
		2044,
		51419,
		45608,
		36720,
		12314,
		6763
	],
	"./src/interactive-quickstarts/try-it-out.mdx": [
		27373,
		2044,
		51419,
		45608,
		36720,
		12314,
		27373
	],
	"./src/interactive-quickstarts/user-controlled-wallets/configure-app.mdx": [
		42705,
		2044,
		51419,
		45608,
		36720,
		12314,
		42705
	],
	"./src/interactive-quickstarts/user-controlled-wallets/create-user-wallet.mdx": [
		92942,
		2044,
		51419,
		45608,
		36720,
		12314,
		92942
	],
	"./src/interactive-quickstarts/user-controlled-wallets/images/explorer.png": [
		55353,
		55353
	],
	"./src/interactive-quickstarts/user-controlled-wallets/images/transactions.png": [
		10929,
		10929
	],
	"./src/interactive-quickstarts/user-controlled-wallets/index.mdx": [
		52096,
		2044,
		51419,
		45608,
		36720,
		12314,
		52096
	],
	"./src/interactive-quickstarts/user-controlled-wallets/initiate-transaction.mdx": [
		5623,
		2044,
		51419,
		45608,
		36720,
		12314,
		5623
	],
	"./src/interactive-quickstarts/user-controlled-wallets/introduction/images/home.png": [
		40494,
		40494
	],
	"./src/interactive-quickstarts/user-controlled-wallets/introduction/index.mdx": [
		8185,
		2044,
		51419,
		45608,
		36720,
		12314,
		8185
	],
	"./src/interactive-quickstarts/user-controlled-wallets/next-steps.mdx": [
		60102,
		2044,
		51419,
		45608,
		36720,
		12314,
		60102
	],
	"./src/navigation": [
		84632,
		84632
	],
	"./src/navigation.legacy": [
		85532,
		85532
	],
	"./src/navigation.legacy.ts": [
		85532,
		85532
	],
	"./src/navigation.ts": [
		84632,
		84632
	],
	"./src/overview/index.mdx": [
		92897,
		2044,
		51419,
		45608,
		36720,
		12314,
		92897
	],
	"./src/overview/quickstarts.mdx": [
		22661,
		2044,
		51419,
		45608,
		36720,
		12314,
		22661
	],
	"./src/overview/try-it-out.mdx": [
		37592,
		2044,
		51419,
		45608,
		36720,
		12314,
		37592
	],
	"./src/release-notes/circle-mint-2024/index.mdx": [
		17320,
		2044,
		51419,
		45608,
		36720,
		12314,
		17320
	],
	"./src/release-notes/circle-mint-2025/index.mdx": [
		8532,
		2044,
		51419,
		45608,
		36720,
		12314,
		8532
	],
	"./src/release-notes/cpn-2025/index.mdx": [
		58723,
		2044,
		51419,
		45608,
		36720,
		12314,
		58723
	],
	"./src/release-notes/index.mdx": [
		74317,
		2044,
		51419,
		45608,
		36720,
		12314,
		74317
	],
	"./src/release-notes/stablecoins-2024/index.mdx": [
		7488,
		2044,
		51419,
		45608,
		36720,
		12314,
		7488
	],
	"./src/release-notes/stablecoins-2025/index.mdx": [
		45366,
		2044,
		51419,
		45608,
		36720,
		12314,
		45366
	],
	"./src/release-notes/tokenized-funds-2025/index.mdx": [
		38928,
		2044,
		51419,
		45608,
		36720,
		12314,
		38928
	],
	"./src/release-notes/w3s-2024/index.mdx": [
		5562,
		2044,
		51419,
		45608,
		36720,
		12314,
		5562
	],
	"./src/release-notes/w3s-2025/index.mdx": [
		53559,
		2044,
		51419,
		45608,
		36720,
		12314,
		53559
	],
	"./src/sample-projects/index.mdx": [
		28396,
		2044,
		51419,
		45608,
		36720,
		12314,
		28396
	],
	"./src/sdk-explorer/developer-controlled-wallets/Node.js/getting-started/index.mdx": [
		80801,
		2044,
		51419,
		45608,
		36720,
		12314,
		80801
	],
	"./src/sdk-explorer/developer-controlled-wallets/Python/getting-started/index.mdx": [
		90043,
		2044,
		51419,
		45608,
		36720,
		12314,
		90043
	],
	"./src/sdk-explorer/index.mdx": [
		75103,
		2044,
		51419,
		45608,
		36720,
		12314,
		75103
	],
	"./src/sdk-explorer/smart-contract-platform/Node.js/getting-started/index.mdx": [
		19662,
		2044,
		51419,
		45608,
		36720,
		12314,
		19662
	],
	"./src/sdk-explorer/smart-contract-platform/Python/getting-started/index.mdx": [
		55369,
		2044,
		51419,
		45608,
		36720,
		12314,
		55369
	],
	"./src/sdk-explorer/user-controlled-wallets/Node.js/getting-started/index.mdx": [
		53883,
		2044,
		51419,
		45608,
		36720,
		12314,
		53883
	],
	"./src/sdk-explorer/user-controlled-wallets/Python/getting-started/index.mdx": [
		28699,
		2044,
		51419,
		45608,
		36720,
		12314,
		28699
	],
	"./src/sdks/index.mdx": [
		46324,
		2044,
		51419,
		45608,
		36720,
		12314,
		46324
	],
	"./src/stablecoins/eurc-contract-addresses/index.mdx": [
		76331,
		2044,
		51419,
		45608,
		36720,
		12314,
		76331
	],
	"./src/stablecoins/glossary/index.mdx": [
		17992,
		2044,
		51419,
		45608,
		36720,
		12314,
		17992
	],
	"./src/stablecoins/images/qs-eurc-eth-app-connect.png": [
		16094,
		16094
	],
	"./src/stablecoins/images/qs-eurc-eth-app-transfer.png": [
		66879,
		66879
	],
	"./src/stablecoins/images/qs-usdc-aptos-app-tx.png": [
		87773,
		87773
	],
	"./src/stablecoins/images/qs-usdc-aptos-app-ui.png": [
		95055,
		95055
	],
	"./src/stablecoins/images/qs-usdc-eth-app-connect.png": [
		25312,
		25312
	],
	"./src/stablecoins/images/qs-usdc-eth-app-transfer.png": [
		64988,
		64988
	],
	"./src/stablecoins/images/qs-usdc-sui-app-tx.png": [
		19364,
		19364
	],
	"./src/stablecoins/images/qs-usdc-sui-app-ui.jpg": [
		55330,
		55330
	],
	"./src/stablecoins/paymaster-addresses/index.mdx": [
		99012,
		2044,
		51419,
		45608,
		36720,
		12314,
		99012
	],
	"./src/stablecoins/paymaster-overview/index.mdx": [
		41321,
		2044,
		51419,
		45608,
		36720,
		12314,
		41321
	],
	"./src/stablecoins/quickstart-circle-paymaster/index.mdx": [
		57442,
		2044,
		51419,
		45608,
		36720,
		12314,
		57442
	],
	"./src/stablecoins/quickstart-setup-transfer-usdc-aptos/index.mdx": [
		28442,
		2044,
		51419,
		45608,
		36720,
		12314,
		28442
	],
	"./src/stablecoins/quickstart-setup-transfer-usdc-sei/index.mdx": [
		68153,
		2044,
		51419,
		45608,
		36720,
		12314,
		68153
	],
	"./src/stablecoins/quickstart-setup-transfer-usdc-sonic/index.mdx": [
		42835,
		2044,
		51419,
		45608,
		36720,
		12314,
		42835
	],
	"./src/stablecoins/quickstart-setup-transfer-usdc-sui/index.mdx": [
		17634,
		2044,
		51419,
		45608,
		36720,
		12314,
		17634
	],
	"./src/stablecoins/quickstart-setup-usdc-trustline-xrpl/index.mdx": [
		64730,
		2044,
		51419,
		45608,
		36720,
		12314,
		64730
	],
	"./src/stablecoins/quickstart-transfer-10-eurc-on-chain/index.mdx": [
		46419,
		2044,
		51419,
		45608,
		36720,
		12314,
		46419
	],
	"./src/stablecoins/quickstart-transfer-10-usdc-on-chain/index.mdx": [
		45447,
		2044,
		51419,
		45608,
		36720,
		12314,
		45447
	],
	"./src/stablecoins/quickstart-transfer-10-usdc-on-solana/index.mdx": [
		64774,
		2044,
		51419,
		45608,
		36720,
		12314,
		64774
	],
	"./src/stablecoins/usdc-contract-addresses/index.mdx": [
		30376,
		2044,
		51419,
		45608,
		36720,
		12314,
		30376
	],
	"./src/stablecoins/what-is-eurc/index.mdx": [
		8357,
		2044,
		51419,
		45608,
		36720,
		12314,
		8357
	],
	"./src/stablecoins/what-is-usdc/index.mdx": [
		3135,
		2044,
		51419,
		45608,
		36720,
		12314,
		3135
	],
	"./src/tokenized/images/usyc-bsusyce-buy01.png": [
		278,
		278
	],
	"./src/tokenized/images/usyc-bsusyce-buyallow01.png": [
		50946,
		50946
	],
	"./src/tokenized/images/usyc-bsusyce-sell01.png": [
		59749,
		59749
	],
	"./src/tokenized/images/usyc-bsusyce-sellallow01.png": [
		90964,
		90964
	],
	"./src/tokenized/usyc/overview/index.mdx": [
		16906,
		2044,
		51419,
		45608,
		36720,
		12314,
		16906
	],
	"./src/tokenized/usyc/smart-contracts/index.mdx": [
		15388,
		2044,
		51419,
		45608,
		36720,
		12314,
		15388
	],
	"./src/tokenized/usyc/subscribe-and-redeem/index.mdx": [
		62186,
		2044,
		51419,
		45608,
		36720,
		12314,
		62186
	],
	"./src/tokenized/usyc/web2-apis/index.mdx": [
		78285,
		2044,
		51419,
		45608,
		36720,
		12314,
		78285
	],
	"./src/user-controlled-wallets/configure-app.mdx": [
		83563,
		2044,
		51419,
		45608,
		36720,
		12314,
		83563
	],
	"./src/user-controlled-wallets/create-user-wallet.mdx": [
		51854,
		2044,
		51419,
		45608,
		36720,
		12314,
		51854
	],
	"./src/user-controlled-wallets/images/explorer.png": [
		16960,
		16960
	],
	"./src/user-controlled-wallets/images/transactions.png": [
		84569,
		84569
	],
	"./src/user-controlled-wallets/index.mdx": [
		52063,
		2044,
		51419,
		45608,
		36720,
		12314,
		52063
	],
	"./src/user-controlled-wallets/initiate-transaction.mdx": [
		70251,
		2044,
		51419,
		45608,
		36720,
		12314,
		70251
	],
	"./src/user-controlled-wallets/introduction/images/home.png": [
		61488,
		61488
	],
	"./src/user-controlled-wallets/introduction/index.mdx": [
		91511,
		2044,
		51419,
		45608,
		36720,
		12314,
		91511
	],
	"./src/user-controlled-wallets/next-steps.mdx": [
		7746,
		2044,
		51419,
		45608,
		36720,
		12314,
		7746
	],
	"./src/w3s/airdrop/index.mdx": [
		79557,
		2044,
		51419,
		45608,
		36720,
		12314,
		79557
	],
	"./src/w3s/android-sdk-ui-customization-api/index.mdx": [
		85703,
		2044,
		51419,
		45608,
		36720,
		12314,
		85703
	],
	"./src/w3s/android/index.mdx": [
		65164,
		2044,
		51419,
		45608,
		36720,
		12314,
		65164
	],
	"./src/w3s/api-references/index.mdx": [
		52643,
		2044,
		51419,
		45608,
		36720,
		12314,
		52643
	],
	"./src/w3s/asynchronous-states-and-statuses/index.mdx": [
		5654,
		2044,
		51419,
		45608,
		36720,
		12314,
		5654
	],
	"./src/w3s/authentication-methods/index.mdx": [
		70759,
		2044,
		51419,
		45608,
		36720,
		12314,
		70759
	],
	"./src/w3s/blockchain-compatibility-for-circle-apis/index.mdx": [
		13766,
		2044,
		51419,
		45608,
		36720,
		12314,
		13766
	],
	"./src/w3s/blockchain-confirmations/index.mdx": [
		12775,
		2044,
		51419,
		45608,
		36720,
		12314,
		12775
	],
	"./src/w3s/circle-developer-account/index.mdx": [
		51629,
		2044,
		51419,
		45608,
		36720,
		12314,
		51629
	],
	"./src/w3s/circle-programmable-wallets-an-overview/index.mdx": [
		18908,
		2044,
		51419,
		45608,
		36720,
		12314,
		18908
	],
	"./src/w3s/compliance-engine/index.mdx": [
		74819,
		2044,
		51419,
		45608,
		36720,
		12314,
		74819
	],
	"./src/w3s/compliance-requirements/index.mdx": [
		48549,
		2044,
		51419,
		45608,
		36720,
		12314,
		48549
	],
	"./src/w3s/confirmation-uis/index.mdx": [
		62889,
		2044,
		51419,
		45608,
		36720,
		12314,
		62889
	],
	"./src/w3s/create-your-first-wallet-with-email/index.mdx": [
		80049,
		2044,
		51419,
		45608,
		36720,
		12314,
		80049
	],
	"./src/w3s/create-your-first-wallet-with-social-logins/index.mdx": [
		851,
		2044,
		51419,
		45608,
		36720,
		12314,
		851
	],
	"./src/w3s/deploy-smart-contract-template/index.mdx": [
		51591,
		2044,
		51419,
		45608,
		36720,
		12314,
		51591
	],
	"./src/w3s/deposit-eth-to-arbitrum/index.mdx": [
		7024,
		2044,
		51419,
		45608,
		36720,
		12314,
		7024
	],
	"./src/w3s/developer-account-logs/index.mdx": [
		39929,
		2044,
		51419,
		45608,
		36720,
		12314,
		39929
	],
	"./src/w3s/developer-console-faucet/index.mdx": [
		5241,
		2044,
		51419,
		45608,
		36720,
		12314,
		5241
	],
	"./src/w3s/developer-controlled-create-your-first-wallet/index.mdx": [
		60651,
		2044,
		51419,
		45608,
		36720,
		12314,
		60651
	],
	"./src/w3s/developer-controlled-receive-an-inbound-transfer/index.mdx": [
		26975,
		2044,
		51419,
		45608,
		36720,
		12314,
		26975
	],
	"./src/w3s/developer-controlled-register-entity-secret/index.mdx": [
		24128,
		2044,
		51419,
		45608,
		36720,
		12314,
		24128
	],
	"./src/w3s/developer-controlled-transfer-tokens-across-wallets/index.mdx": [
		47619,
		2044,
		51419,
		45608,
		36720,
		12314,
		47619
	],
	"./src/w3s/developer-controlled-wallet-quickstart/index.mdx": [
		25225,
		2044,
		51419,
		45608,
		36720,
		12314,
		25225
	],
	"./src/w3s/developer-controlled-wallets/index.mdx": [
		89454,
		2044,
		51419,
		45608,
		36720,
		12314,
		89454
	],
	"./src/w3s/entity-secret-management/index.mdx": [
		91689,
		2044,
		51419,
		45608,
		36720,
		12314,
		91689
	],
	"./src/w3s/erc-1155-multi-token/index.mdx": [
		33353,
		2044,
		51419,
		45608,
		36720,
		12314,
		33353
	],
	"./src/w3s/erc-20-token/index.mdx": [
		48132,
		2044,
		51419,
		45608,
		36720,
		12314,
		48132
	],
	"./src/w3s/erc-721-nft/index.mdx": [
		88699,
		2044,
		51419,
		45608,
		36720,
		12314,
		88699
	],
	"./src/w3s/gas-fees/index.mdx": [
		66091,
		2044,
		51419,
		45608,
		36720,
		12314,
		66091
	],
	"./src/w3s/gas-station-billing/index.mdx": [
		63990,
		2044,
		51419,
		45608,
		36720,
		12314,
		63990
	],
	"./src/w3s/gas-station-paymaster/index.mdx": [
		41400,
		2044,
		51419,
		45608,
		36720,
		12314,
		41400
	],
	"./src/w3s/gas-station-policy-management/index.mdx": [
		96258,
		2044,
		51419,
		45608,
		36720,
		12314,
		96258
	],
	"./src/w3s/gas-station/index.mdx": [
		51517,
		2044,
		51419,
		45608,
		36720,
		12314,
		51517
	],
	"./src/w3s/how-to-recover-passkey/index.mdx": [
		41270,
		2044,
		51419,
		45608,
		36720,
		12314,
		41270
	],
	"./src/w3s/idempotent-requests/index.mdx": [
		65795,
		2044,
		51419,
		45608,
		36720,
		12314,
		65795
	],
	"./src/w3s/images/3406391-API_Log_Filters.png": [
		12179,
		12179
	],
	"./src/w3s/images/8571ce4-cipher_text_registration.webp": [
		6702,
		41815
	],
	"./src/w3s/images/androidsdk-uic-alert01.png": [
		6804,
		6804
	],
	"./src/w3s/images/androidsdk-uic-color-biometrics01.png": [
		13906,
		13906
	],
	"./src/w3s/images/androidsdk-uic-color-confirmtrx01.png": [
		46414,
		46414
	],
	"./src/w3s/images/androidsdk-uic-color-confirmtrx02.png": [
		1905,
		1905
	],
	"./src/w3s/images/androidsdk-uic-color-contractint01.png": [
		21183,
		21183
	],
	"./src/w3s/images/androidsdk-uic-color-pin01.png": [
		79613,
		79613
	],
	"./src/w3s/images/androidsdk-uic-color-recoverpin01.png": [
		81705,
		81705
	],
	"./src/w3s/images/androidsdk-uic-color-secconfirm01.png": [
		42997,
		42997
	],
	"./src/w3s/images/androidsdk-uic-color-secintro01.png": [
		49621,
		49621
	],
	"./src/w3s/images/androidsdk-uic-color-secq01.png": [
		33147,
		33147
	],
	"./src/w3s/images/androidsdk-uic-color-secsummary01.png": [
		30379,
		30379
	],
	"./src/w3s/images/androidsdk-uic-color-sigreq01.png": [
		53112,
		53112
	],
	"./src/w3s/images/androidsdk-uic-color-verifyotp01.png": [
		86141,
		86141
	],
	"./src/w3s/images/androidsdk-uic-color-verifyotp02.png": [
		74229,
		74229
	],
	"./src/w3s/images/androidsdk-uic-confirmpin01.png": [
		90383,
		90383
	],
	"./src/w3s/images/androidsdk-uic-confirmpin02.png": [
		61288,
		61288
	],
	"./src/w3s/images/androidsdk-uic-confirmtrx01.png": [
		86155,
		86155
	],
	"./src/w3s/images/androidsdk-uic-confirmtrx02.png": [
		46473,
		46473
	],
	"./src/w3s/images/androidsdk-uic-confirmtrx04.png": [
		4820,
		4820
	],
	"./src/w3s/images/androidsdk-uic-confirmtrx05.png": [
		40795,
		40795
	],
	"./src/w3s/images/androidsdk-uic-ctrctint01.png": [
		72415,
		72415
	],
	"./src/w3s/images/androidsdk-uic-enterpin01.png": [
		77306,
		24727
	],
	"./src/w3s/images/androidsdk-uic-enterpin02.png": [
		43965,
		43965
	],
	"./src/w3s/images/androidsdk-uic-enterpin03.png": [
		97400,
		97400
	],
	"./src/w3s/images/androidsdk-uic-img-icon01.png": [
		32711,
		32711
	],
	"./src/w3s/images/androidsdk-uic-img-icon02.png": [
		67579,
		67579
	],
	"./src/w3s/images/androidsdk-uic-img-icon03.png": [
		86077,
		86077
	],
	"./src/w3s/images/androidsdk-uic-img-icon04.png": [
		33801,
		33801
	],
	"./src/w3s/images/androidsdk-uic-img-icon05.png": [
		3234,
		3234
	],
	"./src/w3s/images/androidsdk-uic-img-icon06.png": [
		56670,
		17240
	],
	"./src/w3s/images/androidsdk-uic-img-icon07.png": [
		5607,
		5607
	],
	"./src/w3s/images/androidsdk-uic-img-icon08.png": [
		6739,
		6739
	],
	"./src/w3s/images/androidsdk-uic-img-icon09.png": [
		42353,
		42353
	],
	"./src/w3s/images/androidsdk-uic-img-icon10.png": [
		33450,
		33450
	],
	"./src/w3s/images/androidsdk-uic-img-icon11.png": [
		86584,
		86584
	],
	"./src/w3s/images/androidsdk-uic-img-icon12.png": [
		84057,
		84057
	],
	"./src/w3s/images/androidsdk-uic-img-toolbar01.png": [
		12798,
		12798
	],
	"./src/w3s/images/androidsdk-uic-img-toolbar02.png": [
		19438,
		19438
	],
	"./src/w3s/images/androidsdk-uic-newpin01.png": [
		17495,
		17495
	],
	"./src/w3s/images/androidsdk-uic-newpin02.png": [
		57743,
		57743
	],
	"./src/w3s/images/androidsdk-uic-recoverpin01.png": [
		99214,
		99214
	],
	"./src/w3s/images/androidsdk-uic-recoverpin02.png": [
		45190,
		45190
	],
	"./src/w3s/images/androidsdk-uic-recoverpin03.png": [
		70131,
		70131
	],
	"./src/w3s/images/androidsdk-uic-recoverpin04.png": [
		2596,
		2596
	],
	"./src/w3s/images/androidsdk-uic-recoverpin05.png": [
		34866,
		34866
	],
	"./src/w3s/images/androidsdk-uic-recoverpin06.png": [
		59186,
		59186
	],
	"./src/w3s/images/androidsdk-uic-secconfirm01.png": [
		13847,
		13847
	],
	"./src/w3s/images/androidsdk-uic-secintros01.png": [
		40923,
		40923
	],
	"./src/w3s/images/androidsdk-uic-secqcus01.png": [
		48052,
		48052
	],
	"./src/w3s/images/androidsdk-uic-secqcus02.png": [
		52,
		52
	],
	"./src/w3s/images/androidsdk-uic-secqcus03.png": [
		32141,
		32141
	],
	"./src/w3s/images/androidsdk-uic-secsummary01.png": [
		34035,
		34035
	],
	"./src/w3s/images/androidsdk-uic-sigreq01.png": [
		65282,
		65282
	],
	"./src/w3s/images/androidsdk-uic-sigreq02.png": [
		87116,
		87116
	],
	"./src/w3s/images/androidsdk-uic-style01.png": [
		17411,
		17411
	],
	"./src/w3s/images/androidsdk-uic-style02.png": [
		49327,
		49327
	],
	"./src/w3s/images/androidsdk-uic-style03.png": [
		88955,
		88955
	],
	"./src/w3s/images/androidsdk-uic-style04.png": [
		40173,
		82175
	],
	"./src/w3s/images/androidsdk-uic-style05.png": [
		91832,
		91832
	],
	"./src/w3s/images/androidsdk-uic-style06.png": [
		65998,
		65998
	],
	"./src/w3s/images/androidsdk-uic-style07.png": [
		63694,
		63694
	],
	"./src/w3s/images/androidsdk-uic-style08.png": [
		41175,
		41175
	],
	"./src/w3s/images/androidsdk-uic-style09.png": [
		82875,
		82875
	],
	"./src/w3s/images/androidsdk-uic-style10.png": [
		64100,
		64100
	],
	"./src/w3s/images/androidsdk-uic-verifyotp01.png": [
		93640,
		93640
	],
	"./src/w3s/images/androidsdk-uic-verifyotp02.png": [
		96816,
		96816
	],
	"./src/w3s/images/apiauth-tpr-enterkey01.png": [
		5865,
		5865
	],
	"./src/w3s/images/apiauth-tpr-enterkeyresp01.png": [
		26179,
		26179
	],
	"./src/w3s/images/apistates-pwstatediagram01.svg": [
		88296,
		88296
	],
	"./src/w3s/images/cea8768-Screenshot_2023-07-24_at_3.11.34_PM.png": [
		31632,
		31632
	],
	"./src/w3s/images/dcw-esm-ciphertextflow01.png": [
		34381,
		34381
	],
	"./src/w3s/images/dcw-esm-configurator01.webp": [
		63857,
		63857
	],
	"./src/w3s/images/devcon-cda-apikeys01.png": [
		36438,
		36438
	],
	"./src/w3s/images/devcon-cda-apikeys01_copy_1.png": [
		15221,
		15221
	],
	"./src/w3s/images/devcon-cda-apikeys02.png": [
		46979,
		46979
	],
	"./src/w3s/images/devcon-cda-keytype01.png": [
		89205,
		89205
	],
	"./src/w3s/images/devcon-cda-keytype01_copy_1.png": [
		48704,
		48704
	],
	"./src/w3s/images/devcon-cda-signup01.png": [
		94152,
		94152
	],
	"./src/w3s/images/devcon-cda-signup01_copy_1.png": [
		77843,
		77843
	],
	"./src/w3s/images/devcon-dal-logs01.png": [
		18759,
		18759
	],
	"./src/w3s/images/devcon-mtm-addmem01.png": [
		22470,
		22470
	],
	"./src/w3s/images/devcon-mtm-adminset01.png": [
		58298,
		58298
	],
	"./src/w3s/images/devcon-mtm-changerole01.png": [
		92427,
		92427
	],
	"./src/w3s/images/devcon-mtm-changerole02.png": [
		43323,
		43323
	],
	"./src/w3s/images/devcon-mtm-changerole03.png": [
		24210,
		24210
	],
	"./src/w3s/images/devcon-mtm-createacc01.png": [
		14491,
		14491
	],
	"./src/w3s/images/devcon-mtm-rmmem01.png": [
		30748,
		30748
	],
	"./src/w3s/images/devcon-mtm-rmmem02.png": [
		5528,
		5528
	],
	"./src/w3s/images/devcon-mtm-team01.png": [
		40415,
		40415
	],
	"./src/w3s/images/fd315ea-DevC_Create_Your_First_Wallet2x.png": [
		6932,
		6932
	],
	"./src/w3s/images/gs-pw-km-keymgmt01.png": [
		69227,
		69227
	],
	"./src/w3s/images/iossdk-uic-allowbiom.png": [
		25433,
		25433
	],
	"./src/w3s/images/iossdk-uic-allowtouchid.png": [
		68902,
		68902
	],
	"./src/w3s/images/iossdk-uic-conftx01.png": [
		15697,
		15697
	],
	"./src/w3s/images/iossdk-uic-conftx02.png": [
		64515,
		64515
	],
	"./src/w3s/images/iossdk-uic-conftx03.png": [
		8848,
		8848
	],
	"./src/w3s/images/iossdk-uic-enterpin01.png": [
		43526,
		43526
	],
	"./src/w3s/images/iossdk-uic-enterpin02.png": [
		67227,
		67227
	],
	"./src/w3s/images/iossdk-uic-enterpin03.png": [
		37461,
		37461
	],
	"./src/w3s/images/iossdk-uic-enterpin04.png": [
		29499,
		29499
	],
	"./src/w3s/images/iossdk-uic-enterverif01.png": [
		48376,
		48376
	],
	"./src/w3s/images/iossdk-uic-enterverif02.png": [
		572,
		572
	],
	"./src/w3s/images/iossdk-uic-jmptodef.png": [
		17448,
		17448
	],
	"./src/w3s/images/iossdk-uic-kinteract01.png": [
		98577,
		98577
	],
	"./src/w3s/images/iossdk-uic-kinteract02.png": [
		93672,
		93672
	],
	"./src/w3s/images/iossdk-uic-pwlocalizable.png": [
		34253,
		34253
	],
	"./src/w3s/images/iossdk-uic-pwlocalization.png": [
		415,
		415
	],
	"./src/w3s/images/iossdk-uic-pwtheme.png": [
		51592,
		51592
	],
	"./src/w3s/images/iossdk-uic-recovermeth01.png": [
		75292,
		75292
	],
	"./src/w3s/images/iossdk-uic-recovermeth02.png": [
		31570,
		31570
	],
	"./src/w3s/images/iossdk-uic-recovermeth03.png": [
		96873,
		96873
	],
	"./src/w3s/images/iossdk-uic-recovermeth04.png": [
		45964,
		45964
	],
	"./src/w3s/images/iossdk-uic-recoverpin01.png": [
		86411,
		86411
	],
	"./src/w3s/images/iossdk-uic-recoverpin02.png": [
		51102,
		51102
	],
	"./src/w3s/images/iossdk-uic-reenterpin01.png": [
		52080,
		52080
	],
	"./src/w3s/images/iossdk-uic-reenterpin02.png": [
		90454,
		90454
	],
	"./src/w3s/images/iossdk-uic-secconf01.png": [
		11565,
		11565
	],
	"./src/w3s/images/iossdk-uic-secconf02.png": [
		49716,
		49716
	],
	"./src/w3s/images/iossdk-uic-secquestion.png": [
		49337,
		49337
	],
	"./src/w3s/images/iossdk-uic-secsmry.png": [
		77468,
		77468
	],
	"./src/w3s/images/iossdk-uic-signreq.png": [
		86215,
		86215
	],
	"./src/w3s/images/iossdk-uic-tgtmembership.png": [
		95558,
		8036
	],
	"./src/w3s/images/iossdk-uic-viewcontroller.png": [
		73886,
		73886
	],
	"./src/w3s/images/mw-setup-apiclientkeys01.png": [
		41054,
		41054
	],
	"./src/w3s/images/mw-setup-clientkeycreated01.png": [
		83230,
		83230
	],
	"./src/w3s/images/mw-setup-clienturl01.png": [
		73222,
		73222
	],
	"./src/w3s/images/mw-setup-createclientkey01.png": [
		55967,
		55967
	],
	"./src/w3s/images/mw-setup-passkey01.png": [
		27012,
		27012
	],
	"./src/w3s/images/mw-wi-ddsh.png": [
		94748,
		94748
	],
	"./src/w3s/images/mw-wi-dinteg-ui.png": [
		23920,
		23920
	],
	"./src/w3s/images/postman-pas-auth01.png": [
		89637,
		89637
	],
	"./src/w3s/images/postman-pas-entsec01.png": [
		30832,
		30832
	],
	"./src/w3s/images/postman-pas-pubkey01.png": [
		96332,
		96332
	],
	"./src/w3s/images/reactsdk-uic-alertpop.png": [
		643,
		643
	],
	"./src/w3s/images/reactsdk-uic-biomallow.png": [
		19536,
		19536
	],
	"./src/w3s/images/reactsdk-uic-biomtouchid.png": [
		36388,
		36388
	],
	"./src/w3s/images/reactsdk-uic-biomverify.png": [
		52021,
		52021
	],
	"./src/w3s/images/reactsdk-uic-colc-enterpin.png": [
		60215,
		60215
	],
	"./src/w3s/images/reactsdk-uic-colc-recmeth01.png": [
		31254,
		31254
	],
	"./src/w3s/images/reactsdk-uic-colc-recmeth02.png": [
		77579,
		77579
	],
	"./src/w3s/images/reactsdk-uic-colc-recoverpin.png": [
		39322,
		39322
	],
	"./src/w3s/images/reactsdk-uic-colc-recoverpin02.png": [
		97671,
		97671
	],
	"./src/w3s/images/reactsdk-uic-colc-secconf.png": [
		21010,
		21010
	],
	"./src/w3s/images/reactsdk-uic-colc-secsummary.png": [
		76115,
		76115
	],
	"./src/w3s/images/reactsdk-uic-conftx01.png": [
		44465,
		44465
	],
	"./src/w3s/images/reactsdk-uic-conftx02.png": [
		14025,
		14025
	],
	"./src/w3s/images/reactsdk-uic-conftx03.png": [
		30492,
		30492
	],
	"./src/w3s/images/reactsdk-uic-ctrctint01.png": [
		65832,
		65832
	],
	"./src/w3s/images/reactsdk-uic-ctrctint02.png": [
		76650,
		76650
	],
	"./src/w3s/images/reactsdk-uic-custchecker.png": [
		69104,
		69104
	],
	"./src/w3s/images/reactsdk-uic-d-ctrctint01.png": [
		27866,
		27866
	],
	"./src/w3s/images/reactsdk-uic-d-ctrctint02.png": [
		89937,
		89937
	],
	"./src/w3s/images/reactsdk-uic-d-signreq01.png": [
		35067,
		35067
	],
	"./src/w3s/images/reactsdk-uic-enterpin01.png": [
		27980,
		27980
	],
	"./src/w3s/images/reactsdk-uic-enterpin02.png": [
		82924,
		82924
	],
	"./src/w3s/images/reactsdk-uic-enterpin03.png": [
		67697,
		67697
	],
	"./src/w3s/images/reactsdk-uic-f-conftx01.png": [
		74961,
		74961
	],
	"./src/w3s/images/reactsdk-uic-f-conftx02.png": [
		82680,
		82680
	],
	"./src/w3s/images/reactsdk-uic-f-ctrctint01.png": [
		11898,
		11898
	],
	"./src/w3s/images/reactsdk-uic-f-signreq01.png": [
		40740,
		40740
	],
	"./src/w3s/images/reactsdk-uic-f-verifyotp01.png": [
		33823,
		33823
	],
	"./src/w3s/images/reactsdk-uic-f-verifyotp02.png": [
		78279,
		78279
	],
	"./src/w3s/images/reactsdk-uic-imgc-biomallow.png": [
		87227,
		87227
	],
	"./src/w3s/images/reactsdk-uic-imgc-enterpin01.png": [
		59159,
		59159
	],
	"./src/w3s/images/reactsdk-uic-imgc-enterpin02.png": [
		53445,
		53445
	],
	"./src/w3s/images/reactsdk-uic-imgc-recmeth.png": [
		3056,
		3056
	],
	"./src/w3s/images/reactsdk-uic-imgc-recoverpin .png": [
		18974,
		18974
	],
	"./src/w3s/images/reactsdk-uic-imgc-selquestion.png": [
		54267,
		54267
	],
	"./src/w3s/images/reactsdk-uic-pwlocalizable.png": [
		98222,
		98222
	],
	"./src/w3s/images/reactsdk-uic-pwlocalization.png": [
		54514,
		54514
	],
	"./src/w3s/images/reactsdk-uic-pwtheme.png": [
		33977,
		33977
	],
	"./src/w3s/images/reactsdk-uic-recoverpin01.png": [
		17580,
		17580
	],
	"./src/w3s/images/reactsdk-uic-recoverpin02.png": [
		49538,
		49538
	],
	"./src/w3s/images/reactsdk-uic-recoverymeth01.png": [
		64957,
		64957
	],
	"./src/w3s/images/reactsdk-uic-recoverymeth02.png": [
		34784,
		34784
	],
	"./src/w3s/images/reactsdk-uic-reenterpin.png": [
		16663,
		16663
	],
	"./src/w3s/images/reactsdk-uic-secconf.png": [
		10514,
		10514
	],
	"./src/w3s/images/reactsdk-uic-secquestion.png": [
		34332,
		34332
	],
	"./src/w3s/images/reactsdk-uic-secsummary.png": [
		3275,
		3275
	],
	"./src/w3s/images/reactsdk-uic-signreq01.png": [
		25762,
		25762
	],
	"./src/w3s/images/reactsdk-uic-signreq02.png": [
		62522,
		62522
	],
	"./src/w3s/images/reactsdk-uic-tgtmember.png": [
		95677,
		95677
	],
	"./src/w3s/images/reactsdk-uic-txtc-biomallow.png": [
		25803,
		25803
	],
	"./src/w3s/images/reactsdk-uic-txtc-conftx.png": [
		62962,
		62962
	],
	"./src/w3s/images/reactsdk-uic-txtc-ctrctint.png": [
		77902,
		77902
	],
	"./src/w3s/images/reactsdk-uic-txtc-enterpin.png": [
		4433,
		4433
	],
	"./src/w3s/images/reactsdk-uic-txtc-recmeth.png": [
		28411,
		28411
	],
	"./src/w3s/images/reactsdk-uic-txtc-secconf.png": [
		88570,
		88570
	],
	"./src/w3s/images/reactsdk-uic-txtc-secquestion.png": [
		4392,
		4392
	],
	"./src/w3s/images/reactsdk-uic-txtc-signreq.png": [
		73785,
		73785
	],
	"./src/w3s/images/reactsdk-uic-txtc-verifycode.png": [
		4013,
		4013
	],
	"./src/w3s/images/reactsdk-uic-verifyotp01.png": [
		3887,
		45770
	],
	"./src/w3s/images/reactsdk-uic-verifyotp02.png": [
		37777,
		37777
	],
	"./src/w3s/images/scp-console-templates01.png": [
		63227,
		63227
	],
	"./src/w3s/images/scp-dnftsc-consolecontracts01.png": [
		33240,
		33240
	],
	"./src/w3s/images/scp-dnftsc-consolemint01.png": [
		22767,
		22767
	],
	"./src/w3s/images/scp-dnftsc-consolemint02.png": [
		50923,
		50923
	],
	"./src/w3s/images/scp-dnftsc-consolewallet01.png": [
		47161,
		47161
	],
	"./src/w3s/images/scp-dsc-erc721openzep01.png": [
		36274,
		36274
	],
	"./src/w3s/images/scp-dsc-erc721solidity01.png": [
		68606,
		68606
	],
	"./src/w3s/images/signing-sa-walletssign01.png": [
		1811,
		1811
	],
	"./src/w3s/images/ucw-am-examplebio01.png": [
		13232,
		13232
	],
	"./src/w3s/images/ucw-am-examplepinrec01.png": [
		68667,
		68667
	],
	"./src/w3s/images/ucw-am-koallaemail01.png": [
		29654,
		29654
	],
	"./src/w3s/images/ucw-am-koallaemail02.png": [
		32848,
		32848
	],
	"./src/w3s/images/ucw-am-koallaemail03.png": [
		42601,
		42601
	],
	"./src/w3s/images/ucw-am-koallasocial01.png": [
		7519,
		7519
	],
	"./src/w3s/images/ucw-am-koallasocial02.png": [
		17315,
		17315
	],
	"./src/w3s/images/ucw-am-userinitwallcreat01.png": [
		42478,
		42478
	],
	"./src/w3s/images/ucw-am-userinitwallcreat02.png": [
		63583,
		63583
	],
	"./src/w3s/images/ucw-am-useronboardem01.png": [
		95984,
		95984
	],
	"./src/w3s/images/ucw-am-useronboardsl01.png": [
		38184,
		38184
	],
	"./src/w3s/images/ucw-cui-conftx01.png": [
		98781,
		98781
	],
	"./src/w3s/images/ucw-cui-conftx02.png": [
		519,
		519
	],
	"./src/w3s/images/ucw-cui-conftx03.png": [
		83493,
		83493
	],
	"./src/w3s/images/ucw-cui-signrawtx.png": [
		87396,
		87396
	],
	"./src/w3s/images/ucw-cui-signreq.png": [
		4092,
		4092
	],
	"./src/w3s/images/ucw-cui-signtx.png": [
		66538,
		66538
	],
	"./src/w3s/images/ucw-cyfucw-sampleapp.png": [
		89673,
		89673
	],
	"./src/w3s/images/ucw-cyfucw-sampleapp02.gif": [
		95873,
		95873
	],
	"./src/w3s/images/ucw-cyfwwe-emailotp01.svg": [
		12333,
		12333
	],
	"./src/w3s/images/ucw-cyfwwe-execchall01.svg": [
		14760,
		14760
	],
	"./src/w3s/images/ucw-cyfwwe-sampleapp01.svg": [
		32133,
		32133
	],
	"./src/w3s/images/ucw-cyfwwe-sampleapp02.svg": [
		43824,
		43824
	],
	"./src/w3s/images/ucw-cyfwwe-sampleapp03.png": [
		59976,
		59976
	],
	"./src/w3s/images/ucw-cyfwwsl-executechallenge01.png": [
		32810,
		32810
	],
	"./src/w3s/images/ucw-cyfwwsl-executechallenge01.svg": [
		91226,
		91226
	],
	"./src/w3s/images/ucw-cyfwwsl-executechallenge01_copy_1.svg": [
		87823,
		87823
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp01.png": [
		42794,
		42794
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp01.svg": [
		53608,
		53608
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp01_copy_1.svg": [
		59333,
		59333
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp02.png": [
		45110,
		45110
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp02.svg": [
		1971,
		1971
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp02_copy_1.svg": [
		57519,
		57519
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp03.png": [
		12645,
		12645
	],
	"./src/w3s/images/ucw-cyfwwsl-sampleapp03_copy_1.png": [
		98327,
		98327
	],
	"./src/w3s/images/ucw-cyfwwsl-socialfb01.png": [
		60576,
		60576
	],
	"./src/w3s/images/ucw-cyfwwsl-socialfb01.svg": [
		54483,
		54483
	],
	"./src/w3s/images/ucw-cyfwwsl-socialfb01_copy_1.svg": [
		50110,
		50110
	],
	"./src/w3s/images/ucw-cyfwwsl-socialgoogle01.png": [
		98057,
		98057
	],
	"./src/w3s/images/ucw-cyfwwsl-socialgoogle01.svg": [
		21225,
		21225
	],
	"./src/w3s/images/ucw-cyfwwsl-socialgoogle01_copy_1.svg": [
		27054,
		27054
	],
	"./src/w3s/images/ucw-cyfwwsl-socialgoogle02.png": [
		86208,
		86208
	],
	"./src/w3s/images/ucw-cyfwwsl-socialgoogle02.svg": [
		54904,
		54904
	],
	"./src/w3s/images/ucw-cyfwwsl-socialgoogle02_copy_1.svg": [
		26643,
		26643
	],
	"./src/w3s/images/ucw-isr-execchall01.svg": [
		72091,
		72091
	],
	"./src/w3s/images/ucw-isr-sigrec01.svg": [
		88854,
		88854
	],
	"./src/w3s/images/ucw-raa-sampleapp01.png": [
		54776,
		54776
	],
	"./src/w3s/images/ucw-raa-sampleapp02.png": [
		64851,
		64851
	],
	"./src/w3s/images/ucw-rapc-sampleapp01.png": [
		76822,
		76822
	],
	"./src/w3s/images/ucw-rapc-sampleapp02.png": [
		87025,
		87025
	],
	"./src/w3s/images/ucw-saot-sampleapp01.png": [
		31458,
		31458
	],
	"./src/w3s/images/ucw-saot-sampleapp02.png": [
		15565,
		83258
	],
	"./src/w3s/images/ucw-sdkafucw-arch.png": [
		86710,
		86710
	],
	"./src/w3s/images/ucw-sotec-confirmtrx01.svg": [
		28045,
		28045
	],
	"./src/w3s/images/ucw-sotec-contractint01.svg": [
		28571,
		28571
	],
	"./src/w3s/images/ucw-sotec-execchall01.svg": [
		89132,
		89132
	],
	"./src/w3s/images/usdcaccess-aua-offrampintflow01.png": [
		62751,
		62751
	],
	"./src/w3s/images/usdcaccess-aua-onrampintflow01.png": [
		88700,
		88700
	],
	"./src/w3s/images/usdcaccess-aua-quotescrn01.png": [
		5091,
		5091
	],
	"./src/w3s/images/usdcaccess-aua-reviewscrn01.png": [
		3512,
		3512
	],
	"./src/w3s/images/usdcaccess-aua-sessionslifecycle01.png": [
		35311,
		35311
	],
	"./src/w3s/images/usdcaccess-aua-widgetkyc01.png": [
		88143,
		88143
	],
	"./src/w3s/images/usdcaccess-aua-widgetkyc02.png": [
		34458,
		34458
	],
	"./src/w3s/images/usdcaccess-aua-widgetpayment01.png": [
		96079,
		96079
	],
	"./src/w3s/images/usdcaccess-aua-widgetreview01.png": [
		23844,
		23844
	],
	"./src/w3s/images/usdcaccess-aua-widgetselect01.png": [
		85426,
		85426
	],
	"./src/w3s/images/usdcaccess-aua-widgetsignin01.png": [
		51327,
		51327
	],
	"./src/w3s/images/webhooks-nl-whlogs01.png": [
		36494,
		36494
	],
	"./src/w3s/images/webhooks-nl-whlogs02.png": [
		25817,
		25817
	],
	"./src/w3s/images/websdk-uic-confirmtrx01.png": [
		60212,
		60212
	],
	"./src/w3s/images/websdk-uic-confirmtrx02.png": [
		9941,
		9941
	],
	"./src/w3s/images/websdk-uic-contractint01.png": [
		54215,
		54215
	],
	"./src/w3s/images/websdk-uic-contractint02.png": [
		54579,
		54579
	],
	"./src/w3s/images/websdk-uic-createpin01.png": [
		75360,
		75360
	],
	"./src/w3s/images/websdk-uic-createpin02.png": [
		66330,
		66330
	],
	"./src/w3s/images/websdk-uic-customrsrc01.png": [
		75904,
		75904
	],
	"./src/w3s/images/websdk-uic-customrsrc02.png": [
		71001,
		71001
	],
	"./src/w3s/images/websdk-uic-customrsrc03.png": [
		68006,
		68006
	],
	"./src/w3s/images/websdk-uic-customrsrc04.png": [
		28044,
		28044
	],
	"./src/w3s/images/websdk-uic-customrsrc05.png": [
		93360,
		93360
	],
	"./src/w3s/images/websdk-uic-customrsrc06.png": [
		85343,
		85343
	],
	"./src/w3s/images/websdk-uic-customrsrc07.png": [
		44806,
		44806
	],
	"./src/w3s/images/websdk-uic-customrsrc08.png": [
		76422,
		76422
	],
	"./src/w3s/images/websdk-uic-customrsrc09.png": [
		15178,
		15178
	],
	"./src/w3s/images/websdk-uic-enterpin01.png": [
		31665,
		31665
	],
	"./src/w3s/images/websdk-uic-enterpin02.png": [
		48222,
		55211
	],
	"./src/w3s/images/websdk-uic-local-common01.png": [
		67060,
		67060
	],
	"./src/w3s/images/websdk-uic-local-common02.png": [
		79130,
		79130
	],
	"./src/w3s/images/websdk-uic-local-common03.png": [
		89696,
		89696
	],
	"./src/w3s/images/websdk-uic-local-common04.png": [
		34133,
		34133
	],
	"./src/w3s/images/websdk-uic-local-common05.png": [
		60630,
		60630
	],
	"./src/w3s/images/websdk-uic-local-common06.png": [
		56878,
		56878
	],
	"./src/w3s/images/websdk-uic-local-confirmtrx01.png": [
		29579,
		29579
	],
	"./src/w3s/images/websdk-uic-local-confirmtrx02.png": [
		36471,
		36471
	],
	"./src/w3s/images/websdk-uic-local-confirmtrx03.png": [
		23841,
		23841
	],
	"./src/w3s/images/websdk-uic-local-contractint01.png": [
		29706,
		29706
	],
	"./src/w3s/images/websdk-uic-local-contractint02.png": [
		89748,
		89748
	],
	"./src/w3s/images/websdk-uic-local-contractint03.png": [
		2133,
		2133
	],
	"./src/w3s/images/websdk-uic-local-createpin01.png": [
		28885,
		28885
	],
	"./src/w3s/images/websdk-uic-local-emailotp01.png": [
		26512,
		26512
	],
	"./src/w3s/images/websdk-uic-local-enterpin01.png": [
		83091,
		83091
	],
	"./src/w3s/images/websdk-uic-local-recoverpin01.png": [
		72790,
		72790
	],
	"./src/w3s/images/websdk-uic-local-recovery01.png": [
		59236,
		59236
	],
	"./src/w3s/images/websdk-uic-local-recovery02.png": [
		50988,
		50988
	],
	"./src/w3s/images/websdk-uic-local-reenterpin01.png": [
		52866,
		52866
	],
	"./src/w3s/images/websdk-uic-local-secconfirm01.png": [
		76206,
		76206
	],
	"./src/w3s/images/websdk-uic-local-secconfirm02.png": [
		98268,
		98268
	],
	"./src/w3s/images/websdk-uic-local-secsummary01.png": [
		39997,
		39997
	],
	"./src/w3s/images/websdk-uic-local-sigrec01.png": [
		8494,
		8494
	],
	"./src/w3s/images/websdk-uic-recoverpin01.png": [
		73033,
		96798
	],
	"./src/w3s/images/websdk-uic-recoverpin02.png": [
		49886,
		49886
	],
	"./src/w3s/images/websdk-uic-recovery01.png": [
		98191,
		98191
	],
	"./src/w3s/images/websdk-uic-reenterpin01.png": [
		25673,
		25673
	],
	"./src/w3s/images/websdk-uic-reenterpin02.png": [
		90691,
		90691
	],
	"./src/w3s/images/websdk-uic-secq01.png": [
		16178,
		16178
	],
	"./src/w3s/images/websdk-uic-secq02.png": [
		40177,
		40177
	],
	"./src/w3s/images/websdk-uic-secq03.png": [
		82803,
		82803
	],
	"./src/w3s/images/websdk-uic-secq04.png": [
		69261,
		69261
	],
	"./src/w3s/images/websdk-uic-secq05.png": [
		81070,
		81070
	],
	"./src/w3s/initiate-a-signature-request/index.mdx": [
		47167,
		2044,
		51419,
		45608,
		36720,
		12314,
		47167
	],
	"./src/w3s/ios-sdk-ui-customization-api/index.mdx": [
		99772,
		2044,
		51419,
		45608,
		36720,
		12314,
		99772
	],
	"./src/w3s/ios/index.mdx": [
		23715,
		2044,
		51419,
		45608,
		36720,
		12314,
		23715
	],
	"./src/w3s/manage-team-members/index.mdx": [
		31119,
		2044,
		51419,
		45608,
		36720,
		12314,
		31119
	],
	"./src/w3s/modular-wallets-android-sdk/index.mdx": [
		55453,
		2044,
		51419,
		45608,
		36720,
		12314,
		55453
	],
	"./src/w3s/modular-wallets-integ-dynamic/index.mdx": [
		17419,
		2044,
		51419,
		45608,
		36720,
		12314,
		17419
	],
	"./src/w3s/modular-wallets-ios-sdk/index.mdx": [
		6285,
		2044,
		51419,
		45608,
		36720,
		12314,
		6285
	],
	"./src/w3s/modular-wallets-key-features/index.mdx": [
		89553,
		2044,
		51419,
		45608,
		36720,
		12314,
		89553
	],
	"./src/w3s/modular-wallets-modules/index.mdx": [
		31295,
		2044,
		51419,
		45608,
		36720,
		12314,
		31295
	],
	"./src/w3s/modular-wallets-passkey/index.mdx": [
		57676,
		2044,
		51419,
		45608,
		36720,
		12314,
		57676
	],
	"./src/w3s/modular-wallets-quickstart/index.mdx": [
		10755,
		2044,
		51419,
		45608,
		36720,
		12314,
		10755
	],
	"./src/w3s/modular-wallets-sdks/index.mdx": [
		67237,
		2044,
		51419,
		45608,
		36720,
		12314,
		67237
	],
	"./src/w3s/modular-wallets-setup/index.mdx": [
		27575,
		2044,
		51419,
		45608,
		36720,
		12314,
		27575
	],
	"./src/w3s/modular-wallets-web-sdk/index.mdx": [
		73406,
		2044,
		51419,
		45608,
		36720,
		12314,
		73406
	],
	"./src/w3s/modular-wallets/index.mdx": [
		5916,
		2044,
		51419,
		45608,
		36720,
		12314,
		5916
	],
	"./src/w3s/monitored-tokens/index.mdx": [
		75589,
		2044,
		51419,
		45608,
		36720,
		12314,
		75589
	],
	"./src/w3s/notification-flows/index.mdx": [
		53241,
		2044,
		51419,
		45608,
		36720,
		12314,
		53241
	],
	"./src/w3s/onboard-users-to-developer-controlled-wallets/index.mdx": [
		90603,
		2044,
		51419,
		45608,
		36720,
		12314,
		90603
	],
	"./src/w3s/postman/index.mdx": [
		13021,
		2044,
		51419,
		45608,
		36720,
		12314,
		13021
	],
	"./src/w3s/programmable-wallet-api-rate-limits/index.mdx": [
		14036,
		2044,
		51419,
		45608,
		36720,
		12314,
		14036
	],
	"./src/w3s/programmable-wallets-account-types/index.mdx": [
		5377,
		2044,
		51419,
		45608,
		36720,
		12314,
		5377
	],
	"./src/w3s/programmable-wallets-batch-operations/index.mdx": [
		40375,
		2044,
		51419,
		45608,
		36720,
		12314,
		40375
	],
	"./src/w3s/programmable-wallets-blockchain-infra/index.mdx": [
		21648,
		2044,
		51419,
		45608,
		36720,
		12314,
		21648
	],
	"./src/w3s/programmable-wallets-infrastructure-models/index.mdx": [
		9327,
		2044,
		51419,
		45608,
		36720,
		12314,
		9327
	],
	"./src/w3s/programmable-wallets-key-mgmt/index.mdx": [
		85714,
		2044,
		51419,
		45608,
		36720,
		12314,
		85714
	],
	"./src/w3s/programmable-wallets-on-solana/index.mdx": [
		30760,
		2044,
		51419,
		45608,
		36720,
		12314,
		30760
	],
	"./src/w3s/programmable-wallets-primitives/index.mdx": [
		47555,
		2044,
		51419,
		45608,
		36720,
		12314,
		47555
	],
	"./src/w3s/programmable-wallets/index.mdx": [
		68768,
		2044,
		51419,
		45608,
		36720,
		12314,
		68768
	],
	"./src/w3s/react-native-sdk-ui-customization-api/index.mdx": [
		83581,
		2044,
		51419,
		45608,
		36720,
		12314,
		83581
	],
	"./src/w3s/react-native-sdk/index.mdx": [
		34914,
		2044,
		51419,
		45608,
		36720,
		12314,
		34914
	],
	"./src/w3s/sample-applications/index.mdx": [
		53868,
		2044,
		51419,
		45608,
		36720,
		12314,
		53868
	],
	"./src/w3s/sandbox-vs-production/index.mdx": [
		93877,
		2044,
		51419,
		45608,
		36720,
		12314,
		93877
	],
	"./src/w3s/scp-deploy-smart-contract/index.mdx": [
		35923,
		2044,
		51419,
		45608,
		36720,
		12314,
		35923
	],
	"./src/w3s/scp-event-monitoring/index.mdx": [
		33834,
		2044,
		51419,
		45608,
		36720,
		12314,
		33834
	],
	"./src/w3s/scp-interact-smart-contract/index.mdx": [
		6683,
		2044,
		51419,
		45608,
		36720,
		12314,
		6683
	],
	"./src/w3s/scp-quickstarts/index.mdx": [
		75938,
		2044,
		51419,
		45608,
		36720,
		12314,
		75938
	],
	"./src/w3s/scp-templates-overview/index.mdx": [
		54129,
		2044,
		51419,
		45608,
		36720,
		12314,
		54129
	],
	"./src/w3s/sdk-architecture-for-user-controlled-wallets/index.mdx": [
		97167,
		2044,
		51419,
		45608,
		36720,
		12314,
		3281
	],
	"./src/w3s/send-a-gasless-transaction/index.mdx": [
		39015,
		2044,
		51419,
		45608,
		36720,
		12314,
		39015
	],
	"./src/w3s/send-an-outbound-transfer-or-execute-contract/index.mdx": [
		42675,
		2044,
		51419,
		45608,
		36720,
		12314,
		42675
	],
	"./src/w3s/sign-tx-chain-id/index.mdx": [
		3654,
		2044,
		51419,
		45608,
		36720,
		12314,
		3654
	],
	"./src/w3s/sign-tx-evm/index.mdx": [
		48575,
		2044,
		51419,
		45608,
		36720,
		12314,
		48575
	],
	"./src/w3s/sign-tx-near/index.mdx": [
		97832,
		2044,
		51419,
		45608,
		36720,
		12314,
		97832
	],
	"./src/w3s/sign-tx-solana/index.mdx": [
		22878,
		2044,
		51419,
		45608,
		36720,
		12314,
		22878
	],
	"./src/w3s/signing-apis/index.mdx": [
		17189,
		2044,
		51419,
		45608,
		36720,
		12314,
		17189
	],
	"./src/w3s/smart-contract-platform/index.mdx": [
		31038,
		2044,
		51419,
		45608,
		36720,
		12314,
		6207
	],
	"./src/w3s/smart-contract-references/index.mdx": [
		29442,
		2044,
		51419,
		45608,
		36720,
		12314,
		29442
	],
	"./src/w3s/supported-blockchains-and-currencies/index.mdx": [
		86330,
		2044,
		51419,
		45608,
		36720,
		12314,
		86330
	],
	"./src/w3s/synchronous-errors/index.mdx": [
		64347,
		2044,
		51419,
		45608,
		36720,
		12314,
		64347
	],
	"./src/w3s/transaction-limits-and-optimizations/index.mdx": [
		93497,
		2044,
		51419,
		45608,
		36720,
		12314,
		93497
	],
	"./src/w3s/tx-screening-alert-mgmt/index.mdx": [
		15983,
		2044,
		51419,
		45608,
		36720,
		12314,
		15983
	],
	"./src/w3s/tx-screening-quickstart/index.mdx": [
		17111,
		2044,
		51419,
		45608,
		36720,
		12314,
		17111
	],
	"./src/w3s/tx-screening-rule-mgmt/index.mdx": [
		28715,
		2044,
		51419,
		45608,
		36720,
		12314,
		28715
	],
	"./src/w3s/tx-screening-testing-guide/index.mdx": [
		8570,
		2044,
		51419,
		45608,
		36720,
		12314,
		8570
	],
	"./src/w3s/tx-screening/index.mdx": [
		86005,
		2044,
		51419,
		45608,
		36720,
		12314,
		86005
	],
	"./src/w3s/unified-wallet-addressing-evm/index.mdx": [
		23667,
		2044,
		51419,
		45608,
		36720,
		12314,
		23667
	],
	"./src/w3s/user-controlled-create-your-first-wallet/index.mdx": [
		64943,
		2044,
		51419,
		45608,
		36720,
		12314,
		64943
	],
	"./src/w3s/user-controlled-initialization-and-wallet-creation-quickstart/index.mdx": [
		9648,
		2044,
		51419,
		45608,
		36720,
		12314,
		9648
	],
	"./src/w3s/user-controlled-receive-inbound-transfer/index.mdx": [
		61873,
		2044,
		51419,
		45608,
		36720,
		12314,
		61873
	],
	"./src/w3s/user-controlled-recover-account/index.mdx": [
		38438,
		2044,
		51419,
		45608,
		36720,
		12314,
		56670
	],
	"./src/w3s/user-controlled-reset-account-pin/index.mdx": [
		46841,
		2044,
		51419,
		45608,
		36720,
		12314,
		46841
	],
	"./src/w3s/user-controlled-send-outbound-transfer/index.mdx": [
		16667,
		2044,
		51419,
		45608,
		36720,
		12314,
		16667
	],
	"./src/w3s/user-controlled-wallets-sdks/index.mdx": [
		87407,
		2044,
		51419,
		45608,
		36720,
		12314,
		87407
	],
	"./src/w3s/user-controlled-wallets/index.mdx": [
		47697,
		2044,
		51419,
		45608,
		36720,
		12314,
		47697
	],
	"./src/w3s/wallet-upgrades/index.mdx": [
		27573,
		2044,
		51419,
		45608,
		36720,
		12314,
		27573
	],
	"./src/w3s/web-sdk-ui-customizations/index.mdx": [
		62518,
		2044,
		51419,
		45608,
		36720,
		12314,
		62518
	],
	"./src/w3s/web/index.mdx": [
		53291,
		2044,
		51419,
		45608,
		36720,
		12314,
		53291
	],
	"./src/w3s/web3-services-api-client-keys-auth/index.mdx": [
		17029,
		2044,
		51419,
		45608,
		36720,
		12314,
		17029
	],
	"./src/w3s/web3-services-notifications-quickstart/index.mdx": [
		17867,
		2044,
		51419,
		45608,
		36720,
		12314,
		17867
	],
	"./src/w3s/webhook-logs/index.mdx": [
		96509,
		2044,
		51419,
		45608,
		36720,
		12314,
		96509
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 16366;
module.exports = webpackAsyncContext;